import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./Login";
import MarketingDashboard from "./MarketingDashboard";

function Gate() {
  const { session, loading } = useAuth();
  if (loading) return null;
  if (!session) return <Login />;
  return <MarketingDashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
